import {Action} from '@ngrx/store';
import * as _ from 'lodash';

import {GroupRolesActionTypes, LoadGroupRolesSuccessAction} from '../actions/group-roles';
import {GroupRolesTemplatesActionTypes} from '../actions/group-roles-templates';
import {UserContextActionTypes} from '../actions/user-context';
import {GroupRole} from '../models/group-role';

export interface GroupRolesTemplatesState {
  array: GroupRole[];
}

const initialState: GroupRolesTemplatesState = {
  array: []
};

export function groupRolesTemplatesReducer(state = initialState, action: Action): GroupRolesTemplatesState {
  switch (action.type) {
    case GroupRolesTemplatesActionTypes.LOAD:
      return handleLoadAction();
    case GroupRolesTemplatesActionTypes.LOAD_SUCCESS:
      return handleLoadSuccessAction(state, action);
    case GroupRolesTemplatesActionTypes.LOAD_FAIL:
      return handleLoadFailAction(state);
    case UserContextActionTypes.CHANGE_CLIENT:
      return handleChangeClientAction();
    default:
      return state;
  }
}

function handleLoadAction(): GroupRolesTemplatesState {
  return initialState;
}

function handleLoadSuccessAction(state: GroupRolesTemplatesState, action: LoadGroupRolesSuccessAction): GroupRolesTemplatesState {
  const newState = _.clone(state);
  newState.array = action.payload;
  return newState;
}

function handleLoadFailAction(state: GroupRolesTemplatesState): GroupRolesTemplatesState {
  const newState = _.clone(state);
  newState.array = [];
  return newState;
}

function handleChangeClientAction(): GroupRolesTemplatesState {
  return { array: [] };
}

export const groupRolesTemplatesSelectors = {
  array: (state: GroupRolesTemplatesState) => _.get(state, 'array', [])
};
